"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var search_1 = require("@usereactify/search");
exports.SearchPageStats = function (props) {
    if (props.isLoading) {
        return React.createElement("div", { className: "leading-normal text-xmd md:text-36 text-arctic md:leading-tightest md:mb-0-8" }, "Search Loading...");
    }
    return props.resultStats.numberOfResults > 0 ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "leading-normal text-xmd md:text-36 text-arctic md:leading-tightest md:mb-0-8" },
            "You searched for ",
            React.createElement("strong", { className: "font-semibold capitalize" }, "'" + props.searchTerm + "'")),
        React.createElement("div", { className: "text-base leading-normal text-grey-dark" },
            props.resultStats.numberOfResults,
            " Products"))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "leading-normal text-xmd md:text-36 text-arctic md:leading-tightest md:mb-0-8" },
            "You searched for ",
            React.createElement("strong", { className: "font-semibold capitalize" }, "'" + props.searchTerm + "'",
                " returned 0 results")),
        React.createElement(Snippets.Button, { className: "flex items-center justify-center block border-none rounded bg-navy h-4-8 w-25-3 mt-7-2 md:mt-8 hover:bg-navy hover:text-arctic mb-2-2 md:mb-0", href: "/" },
            React.createElement("span", { className: "block" }, "Homepage"))));
};
exports.PaginationStats = function (props) {
    var searchContext = search_1.useReactifySearchContext();
    if (props.isLoading || searchContext.results.resultStats == undefined) {
        return null;
    }
    var perPage = searchContext.results.resultStats.displayedResults;
    var currentPage = searchContext.results.resultStats.currentPage + 1;
    var totalProducts = props.resultStats.numberOfResults;
    return totalProducts > 0 ? (React.createElement("span", { className: "text-midnight text-base" }, (currentPage - 1) * perPage + 1 + " - " + (currentPage * perPage > totalProducts ? totalProducts : currentPage * perPage) + " of " + totalProducts + (totalProducts > 1 ? " Products" : " Product"))) : (React.createElement("p", { className: "text-midnight text-base" },
        totalProducts,
        " Products"));
};
